import { render, staticRenderFns } from "./EditTeam.vue?vue&type=template&id=4a1b3a12&scoped=true&"
import script from "./EditTeam.vue?vue&type=script&lang=js&"
export * from "./EditTeam.vue?vue&type=script&lang=js&"
import style0 from "./EditTeam.vue?vue&type=style&index=0&id=4a1b3a12&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1b3a12",
  null
  
)

export default component.exports